module.exports = __webpack_public_path__ + "static/paulina-acevedo-menanteau-d653e7da45b57337edc255aa1381f0f2.jpg";